const ATCAPI = {
    API_HEADER: {
        'Content-Type': 'application/json'
    },
    METHOD_GET_ADDRESS: 'user/address',
    METHOD_SIGNATURE: 'user/signature',
    METHOD_HISTORY: 'user/history',
    METHOD_SET_PENDING_HISTORY: 'user/pendinghistory',
    METHOD_GET_PENDING_HISTORY: 'user/getpendinghistory'
};
export default ATCAPI;